import type { RouteObject } from 'react-router-dom';

import { StubPage } from '@/app/pages/StubPage';
import { defineHandle } from '@/app/routes/types';

import { reportsAccessRoles } from './access';

export const reportsRoutes: RouteObject[] = [
  {
    path: 'reports',
    element: <StubPage titleKey="nav.reports" dataPage="reports/index" />,
    handle: defineHandle({
      roles: [...reportsAccessRoles],
      breadcrumb: 'breadcrumb.home',
      title: 'common:nav.reports',
    }),
  },
];
